/* eslint-disable @typescript-eslint/no-namespace */
import * as Scopes from "./Viewing.Extension.Scopes/Viewing.Extension.ScopesEvents";
import * as TextOverlay from "./Viewing.Extension.TextOverlay/Viewing.Extension.TextOverlayEvents";
import * as TotalCO2 from "./Viewing.Extension.TotalCO2/Viewing.Extension.TotalCO2Events";

export namespace Viewing {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  export namespace Extensions {
    export const SCOPES_INITIALIZED_EVENT: string = Scopes.Viewing.Extensions.SCOPES_INITIALIZED_EVENT;
    export const SCOPES_UNINITIALIZED_EVENT: string = Scopes.Viewing.Extensions.SCOPES_UNINITIALIZED_EVENT;
    export const SCOPES_SELECTION_CHANGED_EVENT: string = Scopes.Viewing.Extensions.SCOPES_SELECTION_CHANGED_EVENT;

    export const TOTALCO2_INITIALIZED_EVENT: string = TotalCO2.Viewing.Extensions.TOTALCO2_INITIALIZED_EVENT;
    export const TOTALCO2_UNINITIALIZED_EVENT: string = TotalCO2.Viewing.Extensions.TOTALCO2_UNINITIALIZED_EVENT;
    export const TOTALCO2_SELECTION_CHANGED_EVENT: string = TotalCO2.Viewing.Extensions.TOTALCO2_SELECTION_CHANGED_EVENT;

    export const TEXTOVERLAY_INITIALIZED_EVENT: string = TextOverlay.Viewing.Extensions.TEXTOVERLAY_INITIALIZED_EVENT;
    export const TEXTOVERLAY_UNINITALIZED_EVENT: string = TextOverlay.Viewing.Extensions.TEXTOVERLAY_UNINITALIZED_EVENT;
    export const TEXTOVERLAY_UPDATE_LEGEND_EVENT: string = TextOverlay.Viewing.Extensions.TEXTOVERLAY_UPDATE_LEGEND_EVENT;
  }
}
